import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useCartStore } from "../store/cartStore";

/**
 * Header Component
 * - Nav: Collections, Shop, Boys, Girls, Infants, Blogs
 * - Mobile menu, Cart, Search — React useState triggers
 * - No Bootstrap JS dependency
 */

const NAV_ITEMS = [
  {
    label: "The Difference",
    path: "/the-difference",
  },
  {
    label: "About Us",
    path: "/about",
  },
  {
    label: "Collections",
    path: "/collections",
  },
  {
    label: "Shop",
    path: "/shop",
  },
  {
    label: "Clothing",
    dropdown: [
      {
        label: "T-Shirts",
        path: "/shop?product_type=TShirt",
      },
      {
        label: "Rompers",
        path: "/shop?product_type=Romper",
      },
    ],
  },
];

const Header = ({ onCartOpen, onSearchOpen, onMobileMenuOpen }) => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const isLoggedIn = !!localStorage.getItem("Token");
  const initCart = useCartStore((state) => state.initCart);
  const cartItemsCount = useCartStore(
    (state) =>
      state.cartData?.items_count ?? state.cartData?.items?.length ?? 0,
  );

  useEffect(() => {
    initCart();
  }, [initCart]);

  return (
    <header id="header" className="header-default">
      <div className="px_15 lg-px_40">
        <div className="row wrapper-header align-items-center">
          {/* ── Mobile hamburger ── */}
          <div className="col-md-4 col-3 tf-lg-hidden">
            <button
              onClick={onMobileMenuOpen}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: 0,
                display: "flex",
                alignItems: "center",
                color: "inherit",
                WebkitTapHighlightColor: "transparent",
                outline: "none",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="16"
                viewBox="0 0 24 16"
                fill="none"
              >
                <path
                  d="M2.00056 2.28571H16.8577C17.1608 2.28571 17.4515 2.16531 17.6658 1.95098C17.8802 1.73665 18.0006 1.44596 18.0006 1.14286C18.0006 0.839753 17.8802 0.549063 17.6658 0.334735C17.4515 0.120408 17.1608 0 16.8577 0H2.00056C1.69745 0 1.40676 0.120408 1.19244 0.334735C0.978109 0.549063 0.857702 0.839753 0.857702 1.14286C0.857702 1.44596 0.978109 1.73665 1.19244 1.95098C1.40676 2.16531 1.69745 2.28571 2.00056 2.28571ZM0.857702 8C0.857702 7.6969 0.978109 7.40621 1.19244 7.19188C1.40676 6.97755 1.69745 6.85714 2.00056 6.85714H22.572C22.8751 6.85714 23.1658 6.97755 23.3801 7.19188C23.5944 7.40621 23.7148 7.6969 23.7148 8C23.7148 8.30311 23.5944 8.59379 23.3801 8.80812C23.1658 9.02245 22.8751 9.14286 22.572 9.14286H2.00056C1.69745 9.14286 1.40676 9.02245 1.19244 8.80812C0.978109 8.59379 0.857702 8.30311 0.857702 8ZM0.857702 14.8571C0.857702 14.554 0.978109 14.2633 1.19244 14.049C1.40676 13.8347 1.69745 13.7143 2.00056 13.7143H12.2863C12.5894 13.7143 12.8801 13.8347 13.0944 14.049C13.3087 14.2633 13.4291 14.554 13.4291 14.8571C13.4291 15.1602 13.3087 15.4509 13.0944 15.6653C12.8801 15.8796 12.5894 16 12.2863 16H2.00056C1.69745 16 1.40676 15.8796 1.19244 15.6653C0.978109 15.4509 0.857702 15.1602 0.857702 14.8571Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </div>

          {/* ── Logo ── */}
          <div className="col-xl-3 col-md-4 col-6">
            <Link to="/" className="logo-header">
              <img
                src="/assets/images/logo.png"
                alt="HueHoppers"
                className="logo"
              />
            </Link>
          </div>

          {/* ── Desktop Nav ── */}
          <div className="col-xl-6 tf-md-hidden">
            <nav className="box-navigation text-center">
              <ul className="box-nav-ul d-flex align-items-center justify-content-center gap-30">
                {NAV_ITEMS.map((item) => (
                  <li
                    key={item.label}
                    className="menu-item"
                    onMouseEnter={() =>
                      item.dropdown && setActiveDropdown(item.label)
                    }
                    onMouseLeave={() => setActiveDropdown(null)}
                    style={{ position: "relative" }}
                  >
                    {item.dropdown ? (
                      <>
                        <a
                          href="#"
                          className="item-link"
                          onClick={(e) => e.preventDefault()}
                        >
                          {item.label}
                          <i className="icon icon-arrow-down" />
                        </a>
                        {/* Dropdown */}
                        {activeDropdown === item.label && (
                          <div
                            className="sub-menu submenu-default"
                            style={{ display: "block" }}
                          >
                            <ul className="menu-list">
                              {item.dropdown.map((sub) => (
                                <li key={sub.label}>
                                  <a
                                    href={sub.path}
                                    className="menu-link-text link text_black-2"
                                    onClick={() => setActiveDropdown(null)}
                                  >
                                    {sub.label}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </>
                    ) : (
                      <Link to={item.path} className="item-link">
                        {item.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* ── Right Icons ── */}
          <div className="col-xl-3 col-md-4 col-3">
            <ul className="nav-icon d-flex justify-content-end align-items-center gap-20">
              {/* Search */}
              <li className="nav-search">
                <button
                  onClick={onSearchOpen}
                  className="nav-icon-item"
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: 0,
                    color: "inherit",
                    WebkitTapHighlightColor: "transparent",
                    outline: "none",
                  }}
                >
                  <i className="icon icon-search" />
                </button>
              </li>

              {/* Account */}
              <li className="nav-account">
                <Link
                  to={isLoggedIn ? "/my-account" : "/login"}
                  className="nav-icon-item"
                >
                  <i className="icon icon-account" />
                </Link>
              </li>

              {/* Wishlist */}
              <li className="nav-wishlist">
                <Link to="/my-account/wishlist" className="nav-icon-item">
                  <i className="icon icon-heart" />
                </Link>
              </li>

              {/* Cart */}
              <li className="nav-cart">
                <Link
                  to={"/cart"}
                  className="nav-icon-item"
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: 0,
                    color: "inherit",
                    WebkitTapHighlightColor: "transparent",
                    outline: "none",
                  }}
                >
                  <i className="icon icon-bag" />
                  <span className="count-box">{cartItemsCount}</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
